import { render, staticRenderFns } from "./projectslider.vue?vue&type=template&id=69e9dfc6&"
import script from "./projectslider.vue?vue&type=script&lang=js&"
export * from "./projectslider.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports